import React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import DeviceMenuComponent from './Device-menu.component';
import ListSkeletonComponent from './List-skeleton.component';
import { Checkbox } from '@ui/components/Checkbox/checkbox';
import { IProps as IMainProps } from './IProps';
import { position } from '@store/Map.store';
import { IStroredSettings } from '@store/Devices.store';

export interface IProps
    extends Pick<
        IMainProps,
        | 'tab'
        | 'page'
        | 'loading'
        | 'deviceBtnHover'
        | 'selectedDevices'
        | 'selectedDevice'
        | 'editedDeviceImei'
        | 'infoDeviceImei'
        | 'settingDeviceImei'
        | 'lang'
        | 'columnVisibilityModel'
        | 'dateFilter'
        | 'fromDateFilter'
        | 'zoom'
        | 'toDateFilter'
        | 'sortModel'
        | 'onDeviceSelect'
        | 'onDeviceClick'
        | 'onDeviceDeleteOpen'
        | 'onDeviceDescriptionOpen'
        | 'onDeviceTelemetryOpen'
        | 'onDeviceBtnHoverStart'
        | 'onDeviceBtnHoverStop'
        | 'onDeviceSettingsOpen'
        | 'onDeviceInfoOpen'
    > {
    name: string;
    speed: number;
    batteryVoltage: number;
    date: number | Date | null;
    id: string;
    coords?: position;
    settings: IStroredSettings;
}

const Component: React.FC<IProps> = ({
    page,
    name,
    batteryVoltage,
    date,
    loading,
    id,
    deviceBtnHover,
    selectedDevices,
    selectedDevice,
    editedDeviceImei,
    infoDeviceImei,
    settingDeviceImei,
    lang,
    columnVisibilityModel,
    coords,
    dateFilter,
    fromDateFilter,
    zoom,
    toDateFilter,
    sortModel,
    settings,
    onDeviceSelect,
    onDeviceClick,
    onDeviceDeleteOpen,
    onDeviceDescriptionOpen,
    onDeviceTelemetryOpen,
    onDeviceBtnHoverStart,
    onDeviceBtnHoverStop,
    onDeviceSettingsOpen,
    onDeviceInfoOpen,
}: IProps) => {
    const getChecked = () => {
        if (page === 'history' || page === 'support') {
            return id === selectedDevice;
        } else {
            return selectedDevices.indexOf(id) > -1;
        }
    };
    const isSelected =
        infoDeviceImei === id ||
        editedDeviceImei === id ||
        settingDeviceImei === id ||
        (page === 'history' && id === selectedDevice) ||
        (page === 'support' && id === selectedDevice);
    const popperClass = deviceBtnHover
        ? 'hidden'
        : 'groups__item-menu-tooltip-popper';
    const checked = getChecked();
    if (!loading) {
        return (
            // <Tooltip
            //     classes={{
            //         popper: popperClass,
            //         tooltip: 'groups__item-menu-tooltip',
            //     }}
            //     title={`IMEI: ${id}`}
            //     placement="top"
            //     followCursor
            // >
                <ListItemButton
                    className="device__item"
                    component="li"
                    selected={isSelected}
                    id={id}
                    onClick={onDeviceClick}
                >
                    <Checkbox
                        name={name}
                        value={id}
                        status={checked ? 'checked' : 'unchecked'}
                        onClick={onDeviceSelect}
                    />
                    <ListItemText
                        classes={{
                            root: 'device__text-item',
                            primary: 'device__text',
                        }}
                        primary={name}
                    />
                    <DeviceMenuComponent
                        date={date}
                        batteryVoltage={batteryVoltage}
                        lang={lang}
                        id={id}
                        coords={coords}
                        dateFilter={dateFilter}
                        fromDateFilter={fromDateFilter}
                        toDateFilter={toDateFilter}
                        zoom={zoom}
                        sortModel={sortModel}
                        settings={settings}
                        columnVisibilityModel={columnVisibilityModel}
                        onDeviceTelemetryOpen={onDeviceTelemetryOpen}
                        onDeviceBtnHoverStart={onDeviceBtnHoverStart}
                        onDeviceBtnHoverStop={onDeviceBtnHoverStop}
                        onDeviceInfoOpen={onDeviceInfoOpen}
                        onDeviceSettingsOpen={onDeviceSettingsOpen}
                        onDeviceDeleteOpen={onDeviceDeleteOpen}
                        onDeviceDescriptionOpen={onDeviceDescriptionOpen}
                    />
                </ListItemButton>
            // </Tooltip>
        );
    } else {
        return <ListSkeletonComponent />;
    }
};

const DeviceItemComponent = React.memo(Component);

export default DeviceItemComponent;
